export default "__VITE_ASSET__TsIf3wOu__"